import { useTranslation } from 'react-i18next';

import ConfirmDialog from '@/components/atoms/ConfirmDialog/ConfirmDialog';

type Props = {
  title?: string;
  primaryButtonText?: string;
  children?: React.ReactNode;
  onPrimarySubmit?: () => void;
  primaryButtonDisable?: boolean;
  isSubmitting?: boolean;
  preventClose?: boolean;
  danger?: boolean;
};

const ModalWarn = ({
  title,
  children,
  primaryButtonText,
  onPrimarySubmit,
  primaryButtonDisable,
  isSubmitting,
  preventClose,
  danger,
}: Props) => {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      title={title || t('common.warning')}
      primaryButtonText={primaryButtonText || t('common.close')}
      onConfirm={onPrimarySubmit}
      primaryDisabled={primaryButtonDisable}
      isLoading={isSubmitting}
      preventClose={preventClose}
      danger={danger}
      hideCancel
      closeOnConfirm={false}
    >
      {children}
    </ConfirmDialog>
  );
};

export default ModalWarn;
